"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = exports.Input = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Checkbox_1 = require("./Checkbox");
const File_1 = require("./File");
const Radio_1 = require("./Radio");
const Switch_1 = require("./Switch");
exports.Input = react_1.forwardRef((props, ref) => {
    switch (props.type) {
        case 'file':
            return jsx_runtime_1.jsx(File_1.File, Object.assign({}, props, { ref: ref }), void 0);
        case 'checkbox':
            return jsx_runtime_1.jsx(Checkbox_1.Checkbox, Object.assign({}, props, { ref: ref }), void 0);
        case 'radio':
            return jsx_runtime_1.jsx(Radio_1.Radio, Object.assign({}, props, { ref: ref }), void 0);
        case 'switch':
            return jsx_runtime_1.jsx(Switch_1.Switch, Object.assign({}, props, { ref: ref }), void 0);
        default:
            return jsx_runtime_1.jsx("input", Object.assign({}, props, { ref: ref }), void 0);
    }
});
var TextArea_1 = require("./TextArea");
Object.defineProperty(exports, "TextArea", { enumerable: true, get: function () { return TextArea_1.TextArea; } });
//# sourceMappingURL=index.js.map